export default __webpack_public_path__ + "static/char-v-sp03-173dd69cc1860a2dca1285cb990c809b.png";